import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { SelectOption } from 'components/Select'
import { useGetViewports, ViewportSlice } from 'features/globalSetup/features/viewport'
import { EditSchema } from 'features/inventory/ad-unit/forms/GeneralForm/schemas/editSchema'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { MediaTypeViewportsSchema } from '../../../../schemas/mediaTypesSchema'
import { UseMediaTypeViewports, ViewportOptionSlice } from './types'

export const useMediaTypeViewports = (): UseMediaTypeViewports => {
  const [viewports, setViewports] = useState<ViewportSlice[]>([])

  const { workspaceId } = useWorkspaceParam()

  const { lazyGetViewports } = useGetViewports({ workspaceId })

  const fetchViewports = async () => {
    const viewports = await lazyGetViewports()
    setViewports(viewports)
  }

  useEffect(() => {
    fetchViewports()
  }, [])

  const { watch } = useFormContext<EditSchema>()
  const {
    mediaTypes: { newViewportId, viewportAttributes },
  } = watch()

  const activeViewports: MediaTypeViewportsSchema['viewport'][] = viewportAttributes.map(
    ({ viewport }: MediaTypeViewportsSchema): MediaTypeViewportsSchema['viewport'] => viewport,
  )

  const inactiveViewports: ViewportSlice[] = _.differenceBy(
    viewports,
    activeViewports,
    'viewportId',
  )

  const options: SelectOption<ViewportOptionSlice>[] = inactiveViewports.map(
    ({ name, viewportId }: ViewportSlice): SelectOption<ViewportOptionSlice> => ({
      label: name,
      value: viewportId,
    }),
  )

  const getNewMediaTypeData: UseMediaTypeViewports['getNewMediaTypeData'] = () => {
    const template: undefined | ViewportSlice = inactiveViewports.find(
      (viewport: ViewportSlice): boolean => viewport.viewportId === newViewportId,
    )

    if (template === undefined) {
      return null
    }

    const schema: MediaTypeViewportsSchema = {
      ...template,
      viewport: template,
    }

    const position: number = _.sortedIndexBy(activeViewports, template, 'minimumWidth')

    return [position, schema]
  }

  return { getNewMediaTypeData, options }
}
